import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'

export const usersApi = {
  async getUsers() {
    const url = buildApiUrl(API_ENDPOINTS.USERS)
    return apiRequest(url)
  },

  async getUser(id) {
    const url = buildApiUrl(API_ENDPOINTS.USER_BY_ID(id))
    return apiRequest(url)
  },

  async createUser(userData) {
    const url = buildApiUrl(API_ENDPOINTS.USERS)
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify({ user: userData }),
    })
  },

  async updateUser(id, userData) {
    const url = buildApiUrl(API_ENDPOINTS.USER_BY_ID(id))
    return apiRequest(url, {
      method: 'PUT',
      body: JSON.stringify({ user: userData }),
    })
  },

  async deleteUser(id) {
    const url = buildApiUrl(API_ENDPOINTS.USER_BY_ID(id))
    return apiRequest(url, {
      method: 'DELETE',
    })
  },

  async changePassword(oldPassword, newPassword) {
    const url = buildApiUrl(API_ENDPOINTS.CHANGE_PASSWORD)
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify({
        old_password: oldPassword,
        new_password: newPassword
      }),
    })
  },
}